import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:records-list',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Records List page',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Records List',
    page: { id: prebuilt.Page.Id.SpaceRecordsList },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
